import Select from "react-select";
import normalize from "../utils/NormalizeSelect";

const DriverPricingModelForm = ({
    popup,
    setPopup,
    model,
    setModel,
    processData,
    error,
    setError,
    addMoreSlab,
    removeSlab,
    action,
    isBusy,
}) => {
    return (
        <div
            className={
                popup === "add" || popup === "edit"
                    ? "modal fade show d-block"
                    : "modal fade"
            }
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {popup === "add" ? "Add New" : "Update"} Driver Pricing Model
                        </h5>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                    {/*begin::Input*/}
                                    <label className="form-label required">Model Name</label>
                                    <input
                                        autoComplete="off"
                                        className="form-control"
                                        placeholder="Enter Name"
                                        value={model?.name ?? ""}
                                        onChange={(e) => {
                                            processData("text", e, "name");
                                        }}
                                    />
                                    <small className="text-danger mt-2">
                                        {error?.name ?? ""}
                                    </small>
                                    {/*end::Input*/}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <div className="fv-row fv-plugins-icon-container">
                                    <div className="fv-row">
                                        {/*begin::Label*/}
                                        <label className="required form-label">Model Type</label>
                                        {/*end::Label*/}
                                        {/*begin::Select2*/}
                                        <Select
                                            className="react-select-styled react-select-bordered"
                                            classNamePrefix="react-select"
                                            value={
                                                model?.model
                                                    ? { label: model?.model, value: model?.model }
                                                    : null
                                            }
                                            onChange={(e) => {
                                                processData("select", e, "model");
                                            }}
                                            options={[
                                                {
                                                    value: "Flat Pricing",
                                                    label: "Flat Pricing",
                                                },
                                                {
                                                    value: "Per Kilometer",
                                                    label: "Per Kilometer",
                                                },
                                                {
                                                    value: "Distance Slab",
                                                    label: "Distance Slab",
                                                },
                                            ]}
                                            filterOption={(option, input) => {
                                                return normalize(option.label).includes(normalize(input));
                                            }}
                                            placeholder="Select an option"
                                        />
                                        <small className="text-danger mt-2">
                                            {error?.model ?? ""}
                                        </small>
                                        {/*end::Select2*/}
                                    </div>
                                </div>
                            </div>
                            {model?.model === "Flat Pricing" &&
                                !Array.isArray(model?.price) && (
                                    <div className="col-md-12">
                                        <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                            {/*begin::Input*/}
                                            <label className="form-label required">Payout Per Delivery</label>
                                            <input
                                                autoComplete="off"
                                                className="form-control"
                                                placeholder="Enter Price"
                                                value={model?.price ?? ""}
                                                onChange={(e) => {
                                                    processData("text", e, "price");
                                                }}
                                            />
                                            <small className="text-danger mt-2">
                                                {error?.price ?? ""}
                                            </small>
                                            {/*end::Input*/}
                                        </div>
                                    </div>
                                )}
                            {model?.model === "Per Kilometer" &&
                                !Array.isArray(model?.price) && (
                                    <div className="col-md-12">
                                        <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                            {/*begin::Input*/}
                                            <label className="form-label required">
                                                Payout Per Kilometer
                                            </label>
                                            <input
                                                autoComplete="off"
                                                className="form-control"
                                                placeholder="Enter Price"
                                                value={model?.price ?? ""}
                                                onChange={(e) => {
                                                    processData("text", e, "price");
                                                }}
                                            />
                                            {typeof error?.price === "string" &&
                                                error?.price?.trim() !== "" && (
                                                    <small className="text-danger mt-2">
                                                        {error?.price}
                                                    </small>
                                                )}
                                            {/*end::Input*/}
                                        </div>
                                    </div>
                                )}
                            {model?.model === "Distance Slab" && (
                                <div className="col-md-12">
                                    <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                        {/*begin::Input*/}
                                        <label className="form-label required">Distance Slab</label>
                                        {model?.price?.length > 0 &&
                                            model?.price?.map((item, index) => (
                                                <div className="row" key={index}>
                                                    <div className="col-md-3 mb-3">
                                                        <input
                                                            autoComplete="off"
                                                            className="form-control"
                                                            placeholder="From..."
                                                            value={item?.from ?? ""}
                                                            onChange={(e) => {
                                                                setModel((prev) => {
                                                                    const updatedPrice = [...(prev.price || [])];
                                                                    if (!updatedPrice[index])
                                                                        updatedPrice[index] = {};
                                                                    updatedPrice[index] = {
                                                                        ...updatedPrice[index],
                                                                        from: e.target.value,
                                                                    };

                                                                    return { ...prev, price: updatedPrice };
                                                                });
                                                                setError((prev) => {
                                                                    if (!prev?.price) return prev;
                                                                    const updatedErrors = { ...prev };

                                                                    if (updatedErrors.price[index]?.price) {
                                                                        updatedErrors.price = [
                                                                            ...updatedErrors.price,
                                                                        ];
                                                                        updatedErrors.price[index] = {
                                                                            ...updatedErrors.price[index],
                                                                            from: "",
                                                                        };

                                                                        if (
                                                                            Object.values(
                                                                                updatedErrors.price[index],
                                                                            ).every((v) => !v)
                                                                        ) {
                                                                            updatedErrors.price[index] = {};
                                                                        }

                                                                        if (
                                                                            (updatedErrors.price || []).every(
                                                                                (obj) =>
                                                                                    obj && Object.keys(obj).length === 0,
                                                                            )
                                                                        ) {
                                                                            delete updatedErrors.price;
                                                                        }
                                                                    }

                                                                    return updatedErrors;
                                                                });
                                                            }}
                                                            disabled
                                                        />
                                                        <small className="text-danger mt-2">
                                                            {error?.price?.at(index)?.from ?? ""}
                                                        </small>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <input
                                                            autoComplete="off"
                                                            className="form-control"
                                                            placeholder="To..."
                                                            value={item?.to ?? ""}
                                                            onChange={(e) => {
                                                                setModel((prev) => {
                                                                    const updatedPrice = [...(prev.price || [])];

                                                                    if (!updatedPrice[index])
                                                                        updatedPrice[index] = {};

                                                                    updatedPrice[index] = {
                                                                        ...updatedPrice[index],
                                                                        to: e.target.value,
                                                                    };

                                                                    const toValue = Number(e.target.value);
                                                                    if (
                                                                        !isNaN(toValue) &&
                                                                        updatedPrice[index + 1]
                                                                    ) {
                                                                        updatedPrice[index + 1] = {
                                                                            ...updatedPrice[index + 1],
                                                                            from: toValue + 1,
                                                                        };
                                                                    }

                                                                    return { ...prev, price: updatedPrice };
                                                                });

                                                                setError((prev) => {
                                                                    if (!prev?.price) return prev;
                                                                    const updatedErrors = { ...prev };

                                                                    if (updatedErrors.price[index]?.to) {
                                                                        updatedErrors.price = [
                                                                            ...updatedErrors.price,
                                                                        ];
                                                                        updatedErrors.price[index] = {
                                                                            ...updatedErrors.price[index],
                                                                            to: "",
                                                                        };

                                                                        if (
                                                                            Object.values(
                                                                                updatedErrors.price[index],
                                                                            ).every((v) => !v)
                                                                        ) {
                                                                            updatedErrors.price[index] = {};
                                                                        }

                                                                        if (
                                                                            (updatedErrors.price || []).every(
                                                                                (obj) =>
                                                                                    obj && Object.keys(obj).length === 0,
                                                                            )
                                                                        ) {
                                                                            delete updatedErrors.price;
                                                                        }
                                                                    }

                                                                    return updatedErrors;
                                                                });
                                                            }}
                                                        />
                                                        <small className="text-danger mt-2">
                                                            {error?.price?.at(index)?.to ?? ""}
                                                        </small>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <input
                                                            autoComplete="off"
                                                            className="form-control"
                                                            placeholder="Price"
                                                            value={item?.price ?? ""}
                                                            onChange={(e) => {
                                                                setModel((prev) => {
                                                                    const updatedPrice = [...(prev.price || [])];
                                                                    if (!updatedPrice[index])
                                                                        updatedPrice[index] = {};
                                                                    updatedPrice[index] = {
                                                                        ...updatedPrice[index],
                                                                        price: e.target.value,
                                                                    };

                                                                    return { ...prev, price: updatedPrice };
                                                                });
                                                                setError((prev) => {
                                                                    if (!prev?.price) return prev;
                                                                    const updatedErrors = { ...prev };

                                                                    if (updatedErrors.price[index]?.price) {
                                                                        updatedErrors.price = [
                                                                            ...updatedErrors.price,
                                                                        ];
                                                                        updatedErrors.price[index] = {
                                                                            ...updatedErrors.price[index],
                                                                            price: "",
                                                                        };

                                                                        if (
                                                                            Object.values(
                                                                                updatedErrors.price[index],
                                                                            ).every((v) => !v)
                                                                        ) {
                                                                            updatedErrors.price[index] = {};
                                                                        }

                                                                        if (
                                                                            (updatedErrors.price || []).every(
                                                                                (obj) =>
                                                                                    obj && Object.keys(obj).length === 0,
                                                                            )
                                                                        ) {
                                                                            delete updatedErrors.price;
                                                                        }
                                                                    }

                                                                    return updatedErrors;
                                                                });
                                                            }}
                                                        />
                                                        <small className="text-danger mt-2">
                                                            {error?.price?.at(index)?.price ?? ""}
                                                        </small>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        {index === 0 ? (
                                                            <button
                                                                onClick={addMoreSlab}
                                                                className="btn btn-success w-100"
                                                            >
                                                                <i className="ki-duotone ki-plus-circle text-light-700 fs-1">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                                Add
                                                            </button>
                                                        ) : (
                                                            <div className="d-flex justify-content-between gap-1">
                                                                <div>
                                                                    <button
                                                                        onClick={addMoreSlab}
                                                                        className="btn btn-success btn-sm pe-3"
                                                                        title="Add More"
                                                                    >
                                                                        <i className="ki-duotone ki-plus-circle text-light-700 fs-1">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </button>
                                                                </div>
                                                                <div>
                                                                    <button
                                                                        onClick={() => {
                                                                            removeSlab(index);
                                                                        }}
                                                                        className="btn btn-danger btn-sm pe-3"
                                                                        title="Remove Slab"
                                                                    >
                                                                        <i className="ki-duotone ki-minus-circle text-light-700 fs-1">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        <div className="row">
                                            <div className="col-md-12 text-center">
                                                <small className="text-danger">
                                                    {error?.slab ?? ""}
                                                </small>
                                            </div>
                                        </div>
                                        {/*end::Input*/}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            onClick={() => {
                                setModel({});
                                setPopup("");
                                setError({});
                            }}
                            type="button"
                            className="btn btn-light btn-sm"
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            disabled={isBusy}
                            className="btn btn-light btn-sm"
                            onClick={() => action(popup)}
                        >
                            {isBusy && (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            {popup === "add" ? "Add" : "Update"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DriverPricingModelForm;